import React from "react";
import { Spin } from "antd";

interface IProps {
    style?: React.CSSProperties | undefined;
}

export const QmFormLoading = ({ style }: IProps) => {
    return (
        <div style={{ width: "100%", paddingTop: "2rem", paddingBottom: "2rem", minHeight: "2rem", ...style }}>
            <Spin tip={"Carregando"}>
                <div />
            </Spin>
        </div>
    );
};
